




import Vue from "vue";
import Component from "vue-class-component";
import ReportsShow from "@/components/reports/reports.show.component.vue";

@Component({
  props: {},
  components: {
    ReportsShow
  }
})
export default class SheetCards extends Vue {}
